import styled from "styled-components";

export const Styled = styled.button`
  background-color: #3c4d5c;
  border: 1px solid #3c4d5c;
  padding: 5px 10px;
`;
